module.exports = __webpack_public_path__ + "static/img/Mark.Thompson.b4938a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Mark.Thompson.jpg
// module id = 8U8S
// module chunks = 0